<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="550px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Add dictionary</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                        v-model="edited.languageId"
                        :disabled="saving"
                        :items="languagesToCreateSourceDictionaries"
                        :rules="[required]"
                        item-text="name"
                        item-value="id"
                        label="Language"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Отменить</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { SOURCE_DICTIONARY_CREATE } from '../store/action-types'

const COMMON_ERROR = 'Error has occurred while saving'

export default {
  props: ['value'],
  data () {
    return {
      valid: false,
      saving: false,
      errorOnSave: COMMON_ERROR,
      showErrorOnSave: false,
      edited: this.defaultModel()
    }
  },
  computed: {
    ...mapGetters([
      'languagesToCreateSourceDictionaries'
    ])
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      this.edited = this.defaultModel()
    }
  },
  methods: {
    defaultModel () {
      return {
        languageId: null
      }
    },
    validate () {
      this.errorOnSave = COMMON_ERROR
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        await this.$store.dispatch(SOURCE_DICTIONARY_CREATE, this.edited)
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
